import React from 'react'
import './header.css'
import Headerbutton from './headerbutton'
import Myimg from '../../items/Pic1.png'
import HeadSocials from './header_socials'
import { TypeAnimation } from 'react-type-animation';

const Header = () => {
  return (
    <header>
      <div className="container header__container">
        {/*<h5>Hello I am</h5>
        <h1>Kshitij Jaiswal</h1>
  <h5 className="text-light">Web Developer</h5>*/}
        <TypeAnimation
          sequence={[
            'Hello I am',
            1000,
            () => {
            }
          ]}
          wrapper="h5"
          speed={75}
          cursor={false}
        />
        <TypeAnimation
          sequence={[
            'Kshitij Jaiswal', // Types 'One'
            3000,
            () => {
            }
          ]}
          wrapper="h1"
          speed={40}
          cursor={false}
        />
        <TypeAnimation
          sequence={[
            'Web Developer',
            1500,
            'Angular Developer',
            1500,
            'Works at Wisteli',
            1500,
            () => {
            }
          ]}
          wrapper="h3"
          repeat={Infinity}
          speed={60}
          cursor={false}
          style={{ color: '#d3d3d3' }}
        />
        <Headerbutton />
        <HeadSocials />
        <div className="myimg">
          <img src={Myimg} alt="My Image" />
        </div>
        <a href="#contact" className='scroll__down'>Scroll Down</a>
      </div>
    </header>
  )
}

export default Header